import flatten from 'flat-util';

export const flatToTree = (
  questions,
  parentQuestionId = null,
  nestingLevel = 0,
) => {
  return questions
    .map(q => ({
      checklistQuestionId: q.checklistQuestionId,
      checklistQuestionIdAlias: q.checklistQuestionIdAlias || null,
      isQuickActive: q.isQuickActive,
      quickResultId: q.quickResultId,
      isHiddenInDraftCap: q.isHiddenInDraftCap || false,
      conditions: (q.conditions || []).map(c => ({
        action: c.action,
        checklistQuestionId: c.checklistQuestionId,
        logicalOperator: c.logicalOperator,
        position: c.position,
        resultId: c.resultId,
      })),
      alerts: (q.alerts || []).map(a => ({
        resultFamilyOutcomeId: a.resultFamilyOutcomeId,
        negativeAlert: a.negativeAlert,
        negativeSeverityId: a.negativeSeverityId || null,
      })),
      nestingLevel,
      position: q.position,
      resultFamilyId: q.resultFamilyId,
    }));
};

export const treeToFlat = questions => {
  return questions.sort((a, b) => a.position - b.position);
};

export const getChildrenIds = (questions, questionId, field) => {
  return flatten(questions
    .filter(v => {
      return v.conditions.map(c => c[field]).indexOf(questionId) !== -1;
    })
    .map(v => [v[field], ...getChildrenIds(questions, v[field], field)]), true);
};
